"use strict";

import template from "./app.html";

export default {
  template: template,
};

